export default __webpack_public_path__ + "static/19_34-940eda0df5569cf51532f22108639441.png";